import { FC, useRef, useState } from "react";
import { useOutsideClick } from "../../Utils/useOutsideClick";
import { Icon } from "../Icon/Icon";
import "./CategoryFilter.css";

type Props = {
  categories: string[];
  selectedCategories: string[];
  onChange: (selected: string[]) => void;
};

export const CategoryFilter: FC<Props> = ({
  categories,
  selectedCategories,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    if (isOpen) setIsOpen(false);
  });

  const toggleCategory = (category: string) => {
    if (selectedCategories.includes(category)) {
      onChange(selectedCategories.filter((c) => c !== category));
    } else {
      onChange([...selectedCategories, category]);
    }
  };

  const clearAll = () => {
    onChange([]);
  };

  const selectAll = () => {
    onChange([...categories]);
  };

  const label =
    selectedCategories.length === 0
      ? "Alle kategorier"
      : selectedCategories.length === 1
      ? selectedCategories[0]
      : `${selectedCategories.length} kategorier`;

  return (
    <div className="CategoryFilter" ref={ref}>
      <div
        className="CategoryFilter__trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="CategoryFilter__label">{label}</span>
        <Icon name="arrowDown" width={11} className="CategoryFilter__icon" />
      </div>
      {isOpen && (
        <div className="CategoryFilter__dropdown">
          <div className="CategoryFilter__actions">
            <button
              className="CategoryFilter__action-btn"
              onClick={selectAll}
              type="button"
            >
              Vælg alle
            </button>
            <button
              className="CategoryFilter__action-btn"
              onClick={clearAll}
              type="button"
            >
              Ryd filter
            </button>
          </div>
          <div className="CategoryFilter__options">
            {categories.map((category) => (
              <label
                key={category}
                className="CategoryFilter__option"
              >
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(category)}
                  onChange={() => toggleCategory(category)}
                />
                <span className="CategoryFilter__option-label">
                  {category}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
